import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

const playerWeapon = {
  key: String,
  name: String,
  rarity: String,
  id: String,
};

export const playerWeaponStat = {
  kills: Number,
  headshots: Number,
  hits: Number,
  totalShots: Number,
  criticalDamageDoneToPlayers: Number,
  damageDoneToPlayers: Number,
  damageDoneToStructures: Number,
  weapon: playerWeapon,
} satisfies ModelDefinition;

const validateFn = createModel({
  data: {
    playerWeaponStats: [playerWeaponStat],
  },
}).transform([playerWeaponStat], (response) => response.data.playerWeaponStats);

export type PlayerWeaponStat = FromModel<typeof playerWeaponStat>;
export type PlayerWeaponStats = FromModel<typeof validateFn>;
export type PlayerWeapon = FromModel<typeof playerWeapon>;
export default validateFn;
